const setCurrencyFxRate = (item, field, previousValue, setField, group, changeValue, info, data, newValue, fxRateResponse) => {

    try {
        let idField = item.id;
        const currentValue = newValue ? newValue : field[idField];

        if (currentValue !== previousValue[idField]) {
            if (item.table === 'trx' && (item.idFieldTable === 'currencyId' || item.idFieldTable === 'fxRate')) {
                for (let key in group) {

                    let nameGroup = key;
                    if (group[nameGroup]) {


                        for (let y = 0; y < group[nameGroup].length; y++) {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {

                                if (item.idFieldTable === 'fxRate' && group[nameGroup][y].fields[i].idFieldTable === 'fxRate') {
                                    let setIdField = group[nameGroup][y].fields[i].id;
                                    setField(prevState => ({
                                        ...prevState,
                                        [setIdField]: changeValue,
                                    }), []);
                                }

                                if (item.idFieldTable === 'currencyId' && group[nameGroup][y].fields[i].idFieldTable === 'fxRate') {
                                    let idField = group[nameGroup][y].fields[i].id;
                                    data.crud.boxes.forEach((itemBoxes) => {
                                        itemBoxes.fields.forEach((itemFields) => {
                                            if (itemFields.idFieldTable === 'fxRate') {
                                                let fxRateResponse1 = fxRateResponse ? fxRateResponse : field[itemFields.id];
                                                if (group[nameGroup][y].fields[i].type.includes('Number')) {
                                                    let step = 0;
                                                    let decimalValueFlag = group[nameGroup][y].fields[i].type.split('ber');
                                                    if (decimalValueFlag.length > 1) {
                                                        if (decimalValueFlag[1])
                                                            step = (decimalValueFlag[1]);
                                                        let valueSplit = fxRateResponse1.split(',');

                                                        if (valueSplit.length > 1) {
                                                            if (Number(valueSplit[1].length) < Number(step)) {
                                                                let ceros = '';
                                                                let dif = Number(step) - Number(valueSplit[1].length);
                                                                for (let o = 0; o < dif; o++) {
                                                                    ceros = ceros + '0';
                                                                }
                                                                fxRateResponse1 = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                            } else {
                                                                fxRateResponse1 = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                            }
                                                        } else {
                                                            if (step > 0) {
                                                                let ceros = '';
                                                                for (let o = 0; o < step; o++) {
                                                                    ceros = ceros + '0';
                                                                }
                                                                fxRateResponse1 = `${valueSplit[0]},${ceros}`;
                                                            }
                                                        }
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: fxRateResponse1,
                                                        }), []);
                                                    }
                                                }
                                            }
                                        })
                                    })
                                }

                                if (item.idFieldTable === 'currencyId' && group[nameGroup][y].fields[i].idFieldTable === 'currencyId') {

                                    let idField = group[nameGroup][y].fields[i].id;
                                    let currencyHeader = newValue ? newValue.id : field[item.id].id;
                                    info.forEach((itemInfo) => {
                                        if (itemInfo.source === 'currency') {
                                            if (Number(currencyHeader) === Number(itemInfo.id))
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: {
                                                        id: itemInfo.id,
                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    }
                                                }), []);
                                        }
                                    })
                                }
                            }
                        }
                    }
                }
            }
        }

    } catch (error) {
        console.log('error set currency fxrate-> ' + error)
    }

}

export default setCurrencyFxRate;